<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="h3">事件通報清單設定</div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              Email名單
              <button
                class="btn btn-primary"
                data-toggle="modal"
                data-target="#exampleModalCenter"
              >
                新增 <i class="fas fa-plus"></i>
              </button>
            </div>
            <hr />
            <div class="row">
              <div class="col-12">
                <table :class="tableStyle">
                  <thead :class="tableThStyle">
                    <tr>
                      <th width="10%">#</th>
                      <th width="30%">姓名</th>
                      <th width="50%">群組</th>
                      <th width="50%">信箱</th>
                      <th width="10%">操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, key) in dashbords"
                      :key="key"
                      :class="tableCenterStyle"
                    >
                      <td>{{ key + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.group }}</td>
                      <td>{{ item.mail }}</td>
                      <td>
                        <button class="btn btn-danger">刪除</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary text-uppercase">
              Line Notify 推播頻道，操作流程如下
              <!-- <button class="btn btn-primary">操作流程</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h5" id="exampleModalCenterTitle">
              新增Email通知清單
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group h6">
              <label for="exampleFormControlSelect1">群組</label>
              <select class="form-control" id="exampleFormControlSelect1">
                <option>請選擇</option>
                <option>處本部</option>
                <option>花蓮</option>
                <option>台東</option>
                <option>綠島</option>
              </select>
            </div>
            <div class="form-group h6">
              <label for="exampleInputEmail1">姓名</label>
              <input
                type="email"
                class="form-control"
                id="exampleInputEmail1"
              />
            </div>

            <div class="form-group h6">
              <label for="exampleInputEmail1">信箱</label>
              <input
                type="email"
                class="form-control"
                id="exampleInputEmail1"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              取消
            </button>
            <button type="button" class="btn btn-primary">新增</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      dashbords: [
        {
          name: "葉大雄",
          group: "處本部",
          mail: "dashon@gmail.com",
        },
        {
          name: "彌豆子",
          group: "花蓮",
          mail: "modo@gmail.com",
        },
      ],
    };
  },
  // components: { DialogModal },
  methods: {
    getTime: function () {
      return moment().subtract("-30", "s").format("YYYY/MM/DD HH:mm");
    },
    selectStreaming: function (item, dashboard) {
      this.$refs.streamingModal.openModal();
      this.selectItem = item;
      this.selectDashoard = dashboard;
    },
  },
};
</script>